import { sentryService } from '@/services/telemetry/sentry';

export default function preloadImage(url: string): Promise<HTMLImageElement> {
  if (!url || typeof url !== 'string') {
    return Promise.reject(
      new Error(`preloadImage: invalid URL (${typeof url})`)
    );
  }

  const startTime = performance.now();

  return new Promise((resolve, reject) => {
    const image = new Image();

    image.onload = () => {
      sentryService.trackMetric(
        'image.preload_time_ms',
        performance.now() - startTime,
        'millisecond',
        { url_suffix: url.slice(-30) }
      );
      resolve(image);
    };

    image.onerror = (event) => {
      const duration = performance.now() - startTime;
      sentryService.trackMetric(
        'image.preload_error_time_ms',
        duration,
        'millisecond'
      );
      sentryService.addBreadcrumb(
        'image',
        'Image preload failed',
        { url_suffix: url.slice(-30), duration_ms: Math.round(duration) },
        'warning'
      );
      reject(
        new Error(`Image preload failed: ${url.slice(-60)}`, { cause: event })
      );
    };

    image.src = url;
  });
}
